<template>
  <div class="inner">
    <AdminLnb /> 
    <slot></slot>
  </div>
</template>

<script>

import AdminLnb from "@/components/AdminLnb"

export default {
  name: "adminMainLayout",
  components: {
    AdminLnb
    //test
  },
  created(){ console.log("@@@@@ adminMainLayout")}
};
</script>